import {
  Button,
  CaretUpOutlinedIcon,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { useHistory } from 'react-router-dom';

type Props = {
  step: number;
  loading?: boolean;
  disableFinish?: boolean;
  handlePrevious?: () => void;
};

export const CreateTeamSteps = ({
  step,
  loading,
  disableFinish,
  handlePrevious,
}: Props) => {
  const history = useHistory();
  const handleSaveAndClose = () => {
    const targetElement = document.querySelector(
      '.next-create-team',
    ) as HTMLElement;
    if (targetElement) {
      targetElement.click();
      history.push('/configurations/teams/');
    }
  };

  return (
    <div className="create-team-steps">
      <h2>Create Team</h2>
      <div className="steps">
        <p className={step >= 1 ? 'active' : ''}>Details</p>
        <span className="icon">
          <CaretUpOutlinedIcon
            width="18px"
            fill={
              step + 1 >= 2 ? 'var(--tru-primary-color)' : 'var(--tru-gunmetal)'
            }
          />
        </span>
        <p className={step >= 2 ? 'active' : ''}>Permissions</p>
        <span className="icon">
          <CaretUpOutlinedIcon
            width="18px"
            fill={
              step + 1 >= 3 ? 'var(--tru-primary-color)' : 'var(--tru-gunmetal)'
            }
          />
        </span>
        <p className={step >= 3 ? 'active' : ''}>Products</p>
        <span className="icon">
          <CaretUpOutlinedIcon
            width="18px"
            fill={
              step + 1 >= 4 ? 'var(--tru-primary-color)' : 'var(--tru-gunmetal)'
            }
          />
        </span>
        <p className={step >= 4 ? 'active' : ''}>Users</p>
      </div>
      <Button
        classes="cancel-create-team"
        type="outlined"
        onClick={() => {
          if (handlePrevious) {
            handlePrevious();
          } else {
            history.goBack();
          }
        }}
      >
        {step > 1 ? 'Previous' : 'Cancel'}
      </Button>
      <Button
        classes="next-create-team"
        type={step === 4 && disableFinish ? 'disabled' : 'primary'}
        htmlType={step === 4 ? 'submit' : undefined}
        loading={loading}
      >
        {step === 4 ? 'Finish' : 'Next'}
      </Button>
      {step !== 1 && (
        <Button onClick={handleSaveAndClose} classes="save-and-close">
          Save & Close
        </Button>
      )}
    </div>
  );
};
